import styles from './AddendaIndicator.module.css';

interface AddendaIndicatorProps {
  count: number;
}

export default function AddendaIndicator({ count }: AddendaIndicatorProps) {
  if (count === 0) return null;

  const handleJump = () => {
    const section = document.querySelector('[data-section="addenda"]');
    section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className={styles.indicator}>
      Addenda ({count}) ·{' '}
      <button type="button" className={styles.jumpLink} onClick={handleJump}>
        Jump to addenda
      </button>
    </div>
  );
}
